import { t } from "@/i18n-js/instance";
import { ConfirmButton } from "@circle-react/components/LiveStreams/common/ConfirmButton";
import { ScreenFrame } from "@circle-react/components/LiveStreams/common/ScreenFrame";
import {
  isBackstage,
  isClosing,
  isEnded,
} from "@circle-react/helpers/liveStreamRoomHelpers";
import { useLinkToRoot } from "@circle-react/hooks/useLinkToRoot";
import type { Room } from "@circle-react/types/Live/Room";
import { Typography } from "@circle-react-uikit/Typography";
import { LoginMessage } from "../LoginMessage";

export interface LandingPageProps {
  hasLeftStream: boolean;
  room: Pick<Room, "id" | "name" | "status"> | undefined;
}

export const LandingPage = ({ room, hasLeftStream }: LandingPageProps) => {
  const { goToCommunityRootPath } = useLinkToRoot();
  const isStreamEnded = !hasLeftStream && (isEnded(room) || isClosing(room));
  const isStreamNotStarted = !hasLeftStream && isBackstage(room);
  const isStreamNotFound = !room;
  const isUserLeft = hasLeftStream;
  return (
    <ScreenFrame>
      <div className="flex flex-col items-center gap-6">
        {isStreamNotStarted && (
          <>
            <div className="text-5xl leading-tight">
              {t("live_streams.public.landing.wave")}
            </div>
            <Typography.TitleXl color="text-white">
              {room?.name}
            </Typography.TitleXl>
            <Typography.BodyMd color="text-gray-300" textAlign="text-center">
              {t("live_streams.public.landing.not_started")}
            </Typography.BodyMd>
          </>
        )}
        {isStreamEnded && (
          <>
            <div className="text-5xl leading-tight">
              {t("live_streams.public.landing.checkered_flag")}
            </div>
            <Typography.TitleXl color="text-white">
              {t("live_streams.public.landing.left")}
            </Typography.TitleXl>
            <Typography.BodyMd color="text-gray-300" textAlign="text-center">
              {t("live_streams.public.landing.ended")}
            </Typography.BodyMd>
          </>
        )}
        {isUserLeft && (
          <>
            <div className="text-5xl leading-tight">
              {t("live_streams.public.landing.hands_raised")}
            </div>
            <Typography.TitleXl color="text-white">
              {t("live_streams.public.landing.left")}
            </Typography.TitleXl>
          </>
        )}
        {isStreamNotFound && (
          <>
            <div className="text-5xl leading-tight">
              {t("live_streams.public.landing.disappointed")}
            </div>
            <Typography.TitleXl color="text-white">
              {t("live_streams.public.landing.not_found_title")}
            </Typography.TitleXl>
            <Typography.BodyMd color="text-gray-300" textAlign="text-center">
              {t("live_streams.public.landing.not_found_description")}
            </Typography.BodyMd>
          </>
        )}
        <div className="mt-2">
          <ConfirmButton onClick={goToCommunityRootPath}>
            {t("live_streams.public.landing.back_to_community_button_label")}
          </ConfirmButton>
        </div>
      </div>
      <LoginMessage />
    </ScreenFrame>
  );
};
